var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.555,
    height: 111.106,
    viewBox: "0 0 115.555 111.106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "success",
    transform: "translate(-1415.527 -98.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75176",
    "data-name": "Group 75176",
    transform: "translate(1403.271 72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_ffffffff",
    "data-name": "#ffffffff",
    transform: "translate(49.602 58.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M221.889,187.973a6.558,6.558,0,0,1,10.9,6.854A9.062,9.062,0,0,1,230.9,197.6c-7.816,8.893-15.577,17.835-23.4,26.715a6.58,6.58,0,0,1-9.31.322c-2.985-3.109-5.908-6.276-8.871-9.406a9.093,9.093,0,0,1-2.208-3.028,6.56,6.56,0,0,1,8.679-8.444,9.447,9.447,0,0,1,3.257,2.654c1.157,1.228,2.3,2.465,3.467,3.684C208.982,202.73,215.415,195.335,221.889,187.973Z",
    transform: "translate(-186.65 -185.915)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_3eb655ff",
    "data-name": "#3eb655ff",
    transform: "translate(12.255 26.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M47.994,16.09A12.335,12.335,0,0,1,57.051,18.1a12.4,12.4,0,0,0,9.124,2,12.9,12.9,0,0,0,5.213-2.182A12.217,12.217,0,0,1,80.742,16.2a12.385,12.385,0,0,1,8.194,6.123c.694,1.219,1.007,2.612,1.724,3.818a12.437,12.437,0,0,0,8.12,6c1.534.373,3.14.2,4.677.567a12.371,12.371,0,0,1,9.166,15.742,12.4,12.4,0,0,0,4.221,13.074,12.374,12.374,0,0,1,1.823,18.241c-.97,1.122-2.284,1.877-3.265,2.99a12.386,12.386,0,0,0-3.168,9.786c.141,1.486.766,2.879.877,4.369a12.381,12.381,0,0,1-12.232,13.622,12.38,12.38,0,0,0-11.035,8.03,12.373,12.373,0,0,1-16.758,7.389c-1.379-.592-2.527-1.6-3.906-2.191a12.316,12.316,0,0,0-10.154-.019c-1.215.518-2.252,1.356-3.425,1.953a12.351,12.351,0,0,1-17.216-6.977,12.384,12.384,0,0,0-8.569-7.81c-1.819-.525-3.751-.257-5.57-.78A12.369,12.369,0,0,1,15.513,94.6a12.423,12.423,0,0,0-2.631-11.72c-.956-1.138-2.268-1.891-3.258-2.99a12.349,12.349,0,0,1,1.587-18.276,12.378,12.378,0,0,0,4.758-10.725,29.754,29.754,0,0,0-.8-3.994A12.355,12.355,0,0,1,27.062,32.422a12.421,12.421,0,0,0,10.269-5.986c.886-1.375,1.208-3.02,2.059-4.41a12.353,12.353,0,0,1,8.6-5.935M60.242,39.672A32.012,32.012,0,1,0,90.15,52.815,32.592,32.592,0,0,0,78.858,43.05,31.972,31.972,0,0,0,60.242,39.672Z",
    transform: "translate(-6.304 -15.907)",
    fill: "#0f4c7d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_89d197ff",
    "data-name": "#89d197ff",
    transform: "translate(36.635 47.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M147.84,117.857a34.3,34.3,0,0,1,19.968,3.624,34.959,34.959,0,0,1,12.112,10.474,34.362,34.362,0,1,1-32.081-14.1m15.185,18.357c-5.195,5.907-10.358,11.842-15.548,17.754-.936-.978-1.854-1.971-2.782-2.956a7.58,7.58,0,0,0-2.614-2.13,5.264,5.264,0,0,0-6.965,6.776,7.3,7.3,0,0,0,1.772,2.43c2.378,2.512,4.723,5.053,7.119,7.548a5.28,5.28,0,0,0,7.471-.258c6.28-7.126,12.507-14.3,18.779-21.438a7.272,7.272,0,0,0,1.514-2.226,5.262,5.262,0,0,0-8.747-5.5Z",
    transform: "translate(-117.612 -117.608)",
    fill: "#5bb6ff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.170e9205a42ddbb2075a2a4ea68356c3.svg";
export { ForwardRef as ReactComponent };